import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_1dfad621-fc79-4cd5-b25a-5a11bf07839e/artifacts/nz9707fn_fulllogo_transparent_nobuffer.png";

const quickLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Capabilities", path: "/capabilities" },
  { name: "Safety", path: "/safety" },
  { name: "Projects", path: "/projects" },
  { name: "Careers", path: "/careers" },
];

const serviceLinks = [
  { name: "Fiber Network Construction", path: "/services#fiber" },
  { name: "Coax/HFC Network Construction", path: "/services#coax" },
  { name: "Fiber Splicing & Testing", path: "/services#splicing" },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt="C&F Communications"
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Carrier-grade fiber and HFC network construction services. 
              Based in Ohio – deploying nationwide. Est. February 2022.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm text-slate-400">
                <Mail className="h-4 w-4 text-[#00B4D8]" />
                <a href="mailto:admin@cfcomm.us" className="hover:text-[#00B4D8] transition-colors" data-testid="footer-email">
                  admin@cfcomm.us
                </a>
              </div>
              <div className="flex items-start gap-3 text-sm text-slate-400">
                <MapPin className="h-4 w-4 text-[#00B4D8] mt-0.5" />
                <span>Ohio<br />Available Nationwide</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6 text-white">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-slate-400 hover:text-[#00B4D8] transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6 text-white">
              Services
            </h3>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-slate-400 hover:text-[#00B4D8] transition-colors"
                    data-testid={`footer-service-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Coverage */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6 text-white">
              Service Areas
            </h3>
            <div className="space-y-4">
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-wider text-[#00B4D8] mb-2">
                  Headquarters
                </h4>
                <ul className="space-y-2">
                  <li className="text-sm text-slate-400">Ohio</li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-wider text-[#00B4D8] mb-2">
                  Nationwide
                </h4>
                <p className="text-sm text-slate-400">
                  Available for deployment across the United States
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-500">
              © {currentYear} C&F Communications. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/vendor" className="text-sm text-slate-500 hover:text-[#00B4D8] transition-colors" data-testid="footer-vendor-link">
                Vendor Portal
              </Link>
              <Link to="/contact" className="text-sm text-slate-500 hover:text-[#00B4D8] transition-colors" data-testid="footer-contact-link">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
